import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/animations/scale.css'; // optional
import BaseComponent from './baseComponent';

// Usage: Just add data-tooltip="Content of the tooltip..."

export default class Tooltip extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.els = [...document.querySelectorAll('[data-tooltip]')];
  }

  init() {
    if (!this.els) {
      return;
    }

    this.els.forEach((el) => {
      this.bindTippy(el);
    });
  }

  bindTippy(el) {
    tippy(el, {
      content: el.dataset.tooltip,
      theme: 'vpb',
      animation: 'scale',
    });

    return this;
  }
}
